import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Minimized from './Minimized';

const styles = theme => ({
  dialogPaper: {
    borderTopLeftRadius: theme.radius.sm,
    borderTopRightRadius: theme.radius.sm,
  },
  dialogTitle: {
    padding: 0,
  },
});

const invalidFormProps = ['classes', 'className'];

function Dialog({
  className,
  classes,
  item,
  ActionsProps,
  ChildComponent,
  ChildComponentProps,
  ...rest
}) {
  Object.keys(ChildComponentProps).forEach((key) => {
    if (invalidFormProps.includes(key)) {
      throw new Error('classes should be passed directly.');
    }
  });

  return (
    <ChildComponent
      {...rest}
      classes={{
        dialogPaper: classNames(classes.dialogPaper, className),
        title: classes.dialogTitle,
      }}
      collection={item.collection}
      title={
        <Minimized
          clickable
          embedded
          item={item}
          ActionsProps={ActionsProps}
        />
      }
      {...ChildComponentProps}
    />
  );
}

Dialog.defaultProps = {
  className: '',
  ChildComponentProps: {},
};

Dialog.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  ActionsProps: PropTypes.object.isRequired,
  ChildComponent: PropTypes.object.isRequired,
  ChildComponentProps: PropTypes.object,
};

export default withStyles(styles)(Dialog);
